module.exports = __webpack_public_path__ + "static/img/header_bg.79a3eca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/mitu/special/head/header_bg.png
// module id = WHBp
// module chunks = 8